import { APIFeatures } from '../util/apifeatures';

export interface APIResponse
{
    getAPIFeature(): APIFeatures;
    getDescription(): string;
}

export class APIResponseDtoImpl implements APIResponse
{
    constructor(private feature: APIFeatures, private description: string /* , str:string */)
    {

    }

    getAPIFeature(): APIFeatures
    {
        return this.feature;
    }

    getDescription(): string
    {
        return this.description;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/apiresponse.tsx